import React from 'react';
import intl from 'react-intl-universal';
import PackActions from '../actions/PackActions';
import PackStore from '../stores/PackStore';
import StateStore from '../stores/StateStore';
import AuthStore from '../stores/AuthStore';

function buildTable(boxes, parent) {
  let r = 0
  let boxes_grouped = [[]]
  boxes.map((b, index) => {
    boxes_grouped[r].push(b)
    b[5] = index + 1 //nr w widoku
    if(b[2] && index < boxes.length-1){ //koniec wiersza
      r++
      boxes_grouped[r] = []
    }
  })
  let colsum = 0
  for(let i=0; i<boxes_grouped[0].length; i++){
      colsum += boxes_grouped[0][0]
  }
  return (
    <tbody>
      {boxes_grouped.map((row, index) => {
        let minRowspan = 9999
        let rows = ([
          <tr key={index}>
            {row.map(box => {
              if (box[1] < minRowspan){
                minRowspan = box[1]
              }
              return (
                <td key={box[5]}
                    colSpan={box[0]}
                    rowSpan={box[1]}
                    data-order={box[3]}
                    className={box[4]?'done':''}
                    onClick={box[4] || typeof parent == 'undefined'?null:parent.selectBox}
                    style={{'width': 100 / colsum * box[0] + '%',
                            'height': (typeof parent == 'undefined'?50:100) * box[1] + 'px'}}>
                  {box[5]}
                </td>
              )
            })}
          </tr>
        ])
        if(minRowspan>1){
          for (var i=0; i<(minRowspan-1); i++){
              rows.push(<tr></tr>)
          }
        }
        return rows
      })}
    </tbody>
  )
}

class BoxesComponent extends React.Component {

  constructor() {
    super();
    this.state = {
      boxes: PackStore.getBoxes(),
      pack: StateStore.getPack(),
      uid: AuthStore.getUser().id,
      pakowalnia_id: AuthStore.getPakowalnia()
    }
    this.onChange = this.onChange.bind(this)
    this.selectBox = this.selectBox.bind(this)
  }

  onChange() {
    this.setState({
      boxes: PackStore.getBoxes()
    });
  }

  componentWillMount() {
    PackStore.addChangeListener(this.onChange)
  }

  componentWillUnmount() {
    PackStore.removeChangeListener(this.onChange)
  }

  componentDidMount() {
    if (this.state.pack){
      PackActions.recieveMultipack(this.state.pack, this.state.uid)
    }
  }

  selectBox(e){
    let order_id = parseInt(e.currentTarget.getAttribute('data-order'))
    PackActions.recieveOrder('', this.state.uid, this.state.pakowalnia_id, this.state.pack, order_id)
  }

  deselectPack() {
    PackActions.selectPack(false)
  }

  render() {
    let boxes = this.state.boxes
    let boxesElement = null
    if (boxes) {
      boxesElement = buildTable(boxes, this)
    }

    return (
      <div>
        <table className="boxy">
          {boxesElement}
        </table>

        <div className="buttons_wrap">
          <button className="pull-left" onClick={this.deselectPack}>{intl.get('Anuluj')}</button>
        </div>
      </div>
    )
  }
}

export { buildTable }
export default BoxesComponent



// WEBPACK FOOTER //
// ./src/components/Boxes.js